import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store'
import './plugins/element.js'
import 'normalize.css'
import '@/assets/css/base.css'
import '@/router/permission'
// 缩略图放大
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import { Message } from 'element-ui'
Viewer.setDefaults({
  url: 'data-source',//大图地址参数
  filter(image) {
    // 只有大图的才能放大
    let dataSource = image.getAttribute('data-source')
    if (dataSource == null || dataSource == undefined) {
      return false
    } else {
      return true
    }
  }
})
Vue.use(Viewer)

// 自动获取焦点
Vue.directive('focus', {
  inserted: function (el) {
    el.querySelector('input').focus()
  }
})

// axios
import axios from 'axios'
// import { from } from 'core-js/core/array'
// 请求延时
axios.defaults.timeout = 30000
// 配置请求的跟路径
// 本地
// axios.defaults.baseURL = 'https://www.xiquesoftware.com/manage'
// 灵鹿到家
axios.defaults.baseURL = 'https://homey.xiquesoftware.com/manage'
// axios请求拦截
axios.interceptors.request.use(config => {
  if (config.url == '/api/sso/refreshToken') {
    config.headers['Authorization'] = sessionStorage.getItem('getToken')
  } else if (config.url != '/api/sso/login' && config.url != '/api/sso/refreshToken') {
    config.headers['Authorization'] = sessionStorage.getItem('token')
  }
  // console.log('config', config);
  // 在最后必须return config
  return config
}, error => {
  return Promise.reject(error)
})
axios.interceptors.response.use(
  res => {
    if (res.data.code == 401) {
      // 401登录过期请重新登录
      Message.error("登录过期，请重新登录!");
      // 清空token
      window.sessionStorage.clear();
      // 清空本地资源列表、渠道列表、门店列表
      localStorage.removeItem("stageArr");
      localStorage.removeItem("labelArr");
      localStorage.removeItem("channelArr");      
      router.push("/login");
    }
    return res 
  },
  error => {
    // errorHandler(error);
    return Promise.reject(error);
  }
);
Vue.prototype.$axios = axios

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
